import React, { useEffect, useState } from "react";
import { Input } from "@material-ui/core";
import { v4 as uuid4 } from "uuid";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import * as _ from "lodash";
import classNames from "classnames";
import style from "./style";
import commonStyle from "../../../Elements/FormElements/sharedStyle";
import { IFormElement } from "../../../Elements/Forms/interface/IFormElement";
import { IFileUpload } from "../../../Elements/Forms/interface/File/IFileUpload";

// Create styles
const useStyles = makeStyles(() => createStyles(style()));
const useCommonStyles = makeStyles(() => createStyles(commonStyle()));

// Props type
type props = {
  onChange: any;
  file: IFileUpload;
  formElement: IFormElement | null;
  disabled: boolean;
  acceptedFiles?:IFileUpload[] | [];
};

const isConfigEmpty = (formElement: IFormElement): boolean => {
  if (_.isNull(formElement.customConfiguration)) {
    return true;
  }
  if (_.isUndefined(formElement.customConfiguration.bucketUpload)) {
    return true;
  }
  if (_.isUndefined(formElement.customConfiguration.bucketUpload.textBox)) {
    return true;
  }
  return false;
};

// UIFileInput Component
export const UIFileInput = (props: props): JSX.Element => {
  const { onChange, file, formElement, disabled, acceptedFiles } = props;
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [Value, setValue] = useState("");
    useEffect(()=>{
    setValue(file.fileInputText);
  },[file.fileInputText]);

  if (_.isNull(formElement)) {
    return <></>;
  }

  if (isConfigEmpty(formElement)) {
    return <></>;
  }



  const Placeholder: string =
    formElement.customConfiguration.bucketUpload?.textBox?.placeholder || "";
  const IsError: any = formElement.customConfiguration.bucketUpload?.textBox
    ?.required
    ? _.isEqual(Value.toString().trim().length, 0) && file.touched
    : false;

  const config:any ={
    isNumber:formElement.customConfiguration.bucketUpload?.textBox?.isNumber || false,
    isLimitAuto:formElement.customConfiguration.bucketUpload?.textBox?.maxValue || "",
    filesLength:formElement.value?.acceptedFiles.length,
    valuesCompare:_.map(acceptedFiles,"fileInputText")
  };
  const {isNumber,isLimitAuto,filesLength,valuesCompare} = config;

  return (
    <Input
      type={isNumber ? "number": "text"}
      disabled={disabled}
      id={uuid4()}
      className={classes.container}
      value={Value}
      placeholder={Placeholder}
      onChange={(event: any): void => {
        let InputValue = event.target.value;
        if (isNumber && _.isEqual(isLimitAuto, "auto")) {
          if (!_.isEqual(InputValue, "") && (_.gt(InputValue, filesLength) || _.lt(InputValue, 1))) {
            return;
          }
          if (_.includes(valuesCompare, InputValue) && !_.isEqual(InputValue, "")) {
            InputValue = "";
          }
          onChange({
            fileInputText: InputValue,
            touched: true,
          });
        }
        setValue(InputValue);
      }}
      inputProps={{
        style: {
          height: 36,
        },
        className: classNames(classes.input, {
          [commonClasses.disabled]: disabled,
          [classes.inputElement]: !disabled && !IsError,
          [commonClasses.error]: IsError,
        }),
        onBlur: () => {
          if(!_.isEqual(Value,file.fileInputText) && !isNumber){
            onChange({
              fileInputText: Value,
              touched: true,
            });
          }
        },
      }}
    />
  );
};
